import { useState, useEffect } from 'react';
import Hero from './components/Hero';
import Testimonials from './components/Testimonials';
import Contact from './components/Contact';
import Navbar from './components/Navbar';

export default function Home() {
  const [isScrolled, setIsScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <div className="relative min-h-screen bg-white">
      <Navbar isScrolled={isScrolled} />
      <main>
        <Hero />
        <Testimonials />
        <Contact />
      </main>
      <footer className="bg-gradient-to-br from-blue-600 via-blue-500 to-blue-400 text-white py-12">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-8 mb-8">
            <div>
              <img 
                src="https://static.readdy.ai/image/4f1580f9373e811b39bfa09d083e9beb/42b5f4c13673639d64638f43fe487fad.png" 
                alt="Facebook Marketing 2026" 
                className="h-12 mb-4"
              />
              <p className="text-white/90 text-sm">
                Master Facebook Marketing and transform your business with proven strategies and expert guidance.
              </p>
            </div>
            <div>
              <h4 className="font-semibold text-lg mb-4">Quick Links</h4>
              <ul className="space-y-2 text-sm">
                <li><a href="#hero" className="text-white/90 hover:text-white transition-colors">Home</a></li>
                <li><a href="#testimonials" className="text-white/90 hover:text-white transition-colors">Testimonials</a></li>
                <li><a href="#contact" className="text-white/90 hover:text-white transition-colors">Contact</a></li>
              </ul>
            </div>
          </div>
          <div className="border-t border-white/20 pt-8 text-center text-sm text-white/80">
            <p>&copy; 2026 Facebook Marketing. All rights reserved. | <a href="https://readdy.ai/?ref=logo" className="hover:text-white transition-colors" rel="nofollow">Website Builder</a></p>
          </div>
        </div>
      </footer>
    </div>
  );
}
